export type TaskNoteProfile = {
    daycareId: number
    count: number
    taskNotes: TaskNote[]
}

export type TaskNote = {
    id: number
    daycareId: number
    title: string
    description: string
    type: TaskNoteType
    status?: TaskNoteStatus
    internalNote: boolean
    date?: string
    startHour?: string
    endHour?: string
    userIds: TaskNoteUserValue[]
    childIds: TaskNoteUserValue[]
    creationDate: string
    updateDate: Date
}

export enum TaskNoteStatus {
    todo = 'todo',
    inProgress = 'inProgress',
    done = 'done',
    leftMessage = 'leftMessage',
    noAnswer = 'noAnswer',
    connected = 'connected',
    cancelled = 'cancelled',
    missed = 'missed',
    schedule = 'schedule'
}

export enum TaskNoteType {
    task = 'task',
    note = 'note',
    call = 'call',
    appointmentInPerson = 'appointmentInPerson',
    appointmentVideoconference = 'appointmentVideoconference'
}

export interface TaskNoteUserValue {
    id: number
    name: string
    isParent?: boolean
}
